export default __webpack_public_path__ + "static/media/arrow_right.3bc05360.svg";